module.exports = __webpack_public_path__ + "img/rar.5e0efcaf.svg";